import { ThemeProvider, calculatePalette } from '@bizzabo/design-system';
import { useRingThemeCustomization } from '@bizzabo/entities';
import useEventFavicon from '../hooks/useEventFavicon';
import { ThemeProviderCustomizationProps } from './ThemeProviderCustomizationProps';

const ThemeProviderCustomization: React.FC<ThemeProviderCustomizationProps> = ({
    eventUniqueName,
    customization,
    children,
}) => {
    useEventFavicon(eventUniqueName);
    const theme = {};
    const ringCustomization = useRingThemeCustomization(eventUniqueName);
    const rawCustomization = customization ?? ringCustomization;

    const customPalette = calculatePalette({
        backgroundColor: rawCustomization?.secondaryColor ?? '#F8F7F3',
        surfaceColor: rawCustomization?.titleColor ?? '#FFFFFF',
        interactiveColor: rawCustomization?.mainColor ?? '#404040',
    });

    return (
        <ThemeProvider customization={customPalette} customTheme={theme}>
            {children}
        </ThemeProvider>
    );
};

export default ThemeProviderCustomization;
